<template>
  <a-card :bordered="false">
    <!-- ボタン操作区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
      <a-button v-if="selectedRowKeys.length > 0" @click="batchDel" icon="close">{{
        this.$t('disp.btn.deleteBatch')
      }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info div-selected-info">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ this.$t('disp.selected') }}
        <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
        {{ this.$t('disp.item') }}
        <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
      </div>-->

      <a-table
        ref="table"
        :bordered="false"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          // 実行されたデータは削除不可
          getCheckboxProps: (record) => ({
            props: {
              disabled: record.isExecute == 1,
            },
          }),
        }"
        @change="handleTableChange"
      >
        <!-- 連番 -->
        <span slot="rowIndex" slot-scope="text, record, index">
          {{ (ipagination.current - 1) * ipagination.pageSize + parseInt(index) + 1 }}
        </span>

        <!-- 実行時間 -->
        <span slot="executeTime" slot-scope="text, record">
          {{ moment(record.executeTime).format('YYYY-MM-DD') }}
        </span>
        <!-- 実行内容 -->
        <span slot="actionContent" slot-scope="text, record">
          <div class="track-wrapper-list timeline" @click="zoomOut">
            <a-timeline>
              <div v-for="actionVo in record.actionHistoryVoList" :key="actionVo.createTime">
                <a-timeline-item :class="getItemColor(actionVo)">
                  <p>
                    <span class="actionVo-date">{{ actionVo.createTime | dateformat('YYYY-MM-DD') }}</span>
                    <span class="actionVo-date note">{{ actionVo.createTime | dateformat(' HH:mm:ss') }}</span>
                  </p>
                  <span class="actionVo-black">{{ actionVo.createName }}</span>
                  &nbsp;
                  <p class="actionVo-info">{{ $t(actionVo.actionType) }}</p>
                  &nbsp;
                  <span
                    class="actionVo-black"
                    :title="actionVo.actionContent"
                    v-html="
                      actionVo.actionContent
                        .replaceAll('disp.nothing', $t('disp.nothing'))
                        .replace('( ', '<span> ( ')
                        .replace(' ) ', ' ) </span>')
                    "
                  ></span>
                </a-timeline-item>
              </div>
            </a-timeline>
          </div>
        </span>

        <!-- 実行可否 -->
        <span slot="isExecute" slot-scope="text, record">
          <a-tag color="green" v-if="record.isExecute == '1'" style="width: 90px">
            {{ $getDict('is_execute', record.isExecute) }}
          </a-tag>
          <a-tag color="orange" v-else style="width: 90px">
            {{ $getDict('is_execute', record.isExecute) }}
          </a-tag>
        </span>

        <!-- 失敗かどうか -->
        <span slot="isFail" slot-scope="text, record">
          <a-tag color="red" v-if="record.isFail == '1'" style="width: 90px">
            {{ $getDict('is_fail', record.isFail) }}
          </a-tag>
          <a-tag color="green" v-if="record.isFail == '0'" style="width: 90px">
            {{ $getDict('is_fail', record.isFail) }}
          </a-tag>
        </span>

        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <div v-if="record.isExecute == 0">
            <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
              <a>{{ $t('disp.btn.delete') }}</a>
            </a-popconfirm>
          </div>
          <div v-else>
            <a @click="handleDetail(record)">{{ $t('disp.flow.detail') }}</a>
          </div>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- フォーム区域 -->
    <action-modal ref="modalForm" @ok="modalFormOk" @searchQuery="searchQuery(true, true)"></action-modal>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import ActionModal from './modules/ActionModal'

export default {
  name: 'ActionManage',
  mixins: [tableMixin],
  components: {
    ActionModal,
  },
  data() {
    return {
      // テーブルタイトル
      columns: [
        //{
        //  title: '#',
        //  dataIndex: '',
        //  key: 'rowIndex',
        //  width: 47,
        //  align: 'center',
        //  scopedSlots: { customRender: 'rowIndex' },
        //},
        {
          title: this.$t('disp.action.executeTime'),
          align: 'center',
          dataIndex: 'executeTime',
          //width: 150,
          scopedSlots: { customRender: 'executeTime' },
          sorter: true,
        },
        {
          title: this.$t('disp.action.changeDiv'),
          scopedSlots: { customRender: 'actionContent' },
        },
        {
          title: this.$t('disp.action.failReason'),
          dataIndex: 'failReason',
          //width: 220,
        },
        {
          title: this.$t('disp.action.isFail'),
          align: 'center',
          dataIndex: 'isFail',
          //width: 110,
          scopedSlots: { customRender: 'isFail' },
        },
        {
          title: this.$t('disp.action.executeStatus.half'),
          align: 'center',
          dataIndex: 'isExecute',
          //width: 110,
          scopedSlots: { customRender: 'isExecute' },
        },
        {
          title: this.$t('disp.operation'),
          dataIndex: 'action',
          align: 'center',
          //width: 110,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/blaze-sys/k00/k0015/Action/list',
        delete: '/blaze-sys/k00/k0015/Action/delete',
        deleteBatch: '/blaze-sys/k00/k0015/Action/deleteBatch',
      },
    }
  },
  computed: {},
  methods: {
    // 履历timeline颜色设置
    getItemColor(actionVo) {
      if (actionVo.actionType.indexOf('delete') > 0) {
        return 'actionVo-red'
      } else if (actionVo.actionType.indexOf('add') > 0) {
        return 'actionVo-primary'
      } else {
        return 'actionVo-blue'
      }
    },
    zoomOut(e) {
      var target = e.target.closest('.track-wrapper-list')
      if (target.classList.contains('zoomOut')) {
        target.classList.remove('zoomOut')
      } else {
        target.classList.add('zoomOut')
      }
    },
  },
}
</script>

<style lang="less">
.track-wrapper-list {
  background: rgba(255, 255, 255, 5%);
  border-radius: 4px;
  padding: 10px;
  max-height: 235px;
  overflow: auto;
  width: calc(100% + 4px);
  cursor: zoom-in;

  .actionVo-primary {
    //padding: 0 0 0 0;
    .ant-timeline-item-head {
      color: green !important;
      border-color: green !important;
    }
    .actionVo-info {
      color: green;
    }
  }

  .actionVo-red {
    //padding: 0 0 0 0;
    .ant-timeline-item-head {
      color: #f5222d !important;
      border-color: #f5222d !important;
    }
    .actionVo-info {
      color: #f5222d;
    }
  }

  .actionVo-blue {
    //padding: 0 0 0 0;
    .ant-timeline-item-head {
      color: #1890ff !important;
      border-color: #1890ff !important;
    }
    .actionVo-info {
      color: #1890ff;
    }
  }

  .actionVo-orange {
    //padding: 0 0 0 0;
    .ant-timeline-item-head {
      color: #fa8c16 !important;
      border-color: #fa8c16 !important;
    }
    .actionVo-info {
      color: #fa8c16;
    }
  }

  .actionVo-cyan {
    //padding: 0 0 0 0;
    .ant-timeline-item-head {
      color: #13c2c2 !important;
      border-color: #13c2c2 !important;
    }
    .actionVo-info {
      color: #13c2c2;
    }
  }

  .actionVo-black {
    color: #5d5151;
  }

  .actionVo-date {
    color: var(--color-grey);
  }

  p.actionVo-info {
    display: inline-block;
    border-bottom: 1px dashed;
  }

  span.actionVo-black > span {
    color: var(--color-grey);
    margin-left: 0.5em;
  }
}

.track-wrapper-list.zoomOut {
  max-height: unset;
  overflow: hidden;
  cursor: zoom-out;
}
</style>
